
export function grabVideos(response){

    var finalVideosArray = [];

    try{ 
        var videoDataRetreived = response.data.items;
        videoDataRetreived.forEach(function(item,index){
            
            //make an array of the characters in the issue. This array will be included in each comicDetailsArray[]
            //turns out this will be done in grabCharacters(), but what the hell
            var eachVideoArray = [];

            eachVideoArray[0] = response.data.items[index].id.videoId;
            eachVideoArray[1] = response.data.items[index].snippet.title;
            eachVideoArray[2] = response.data.items[index].snippet.description;
            eachVideoArray[3] = response.data.items[index].snippet.thumbnails.medium.url;
            eachVideoArray[4] = response.data.items[index].snippet.channelTitle;
            eachVideoArray[5] = response.data.items[index].snippet.publishedAt;
        
            finalVideosArray.push(eachVideoArray);
        });
 

    }
    catch(error) {
        console.log("Couldnt grab a video correctly in grabVideos.js" + error);
    }

    //console.log(finalVideosArray);
    return finalVideosArray;

}//end grabVideos()


// WEBPACK FOOTER //
// ./src/components/includes/grabVideos.js